module.exports = __webpack_public_path__ + "img/botanalysis.cec8e360.svg";